import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import LogAdaptativoList from './logAdaptativoList';

import { getLog } from './logAdaptativoActions';
import { selectTab, showTabs } from '../common/tab/tabActions';
import moment from 'moment';

const defaultDataInicio = () => moment().subtract(1, 'day').format('YYYY-MM-DD');
const defaultDataFim = () => moment().format('YYYY-MM-DD');

class LogAdaptativo extends Component {
  constructor(props) {
    super(props);
    this.listRef = React.createRef();
    this.state = {
      agrupador: 0,
      dataInicio: defaultDataInicio(),
      dataFim: defaultDataFim(),
    };
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    this.fetchLog = this.fetchLog.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
  }

  componentWillMount() {
    this.props.showTabs('tabList');
    this.props.selectTab('tabList');
    this.fetchLog();
  }

  fetchLog(overrides = {}) {
    const agrupador = overrides.agrupador != null ? overrides.agrupador : this.state.agrupador;
    const dataInicio = overrides.dataInicio != null ? overrides.dataInicio : this.state.dataInicio;
    const dataFim = overrides.dataFim != null ? overrides.dataFim : this.state.dataFim;
    this.props.getLog(agrupador, dataInicio, dataFim);
  }

  handleDateRangeChange(field, value) {
    this.setState({ [field]: value }, () => {
      this.fetchLog({ [field]: value });
    });
  }

  handleFilterChange = e => {
    const agrupador = e.target ? e.target.value : this.state.agrupador;
    if (e.target && e.target.id === 'agrupador') {
      this.setState({ agrupador: parseInt(agrupador, 10) });
    }

    setTimeout(() => {
      const nextAgrupador = e.target && e.target.id === 'agrupador' ? parseInt(agrupador, 10) : this.state.agrupador;
      this.fetchLog({ agrupador: nextAgrupador });
    }, 100);
  };

  handlePrint() {
    if (!this.listRef.current) return;
    const instance = this.listRef.current.getWrappedInstance
      ? this.listRef.current.getWrappedInstance()
      : this.listRef.current;
    if (instance && instance.imprimirRelatorio) {
      instance.imprimirRelatorio();
    }
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <div
                style={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  padding: '4px 12px 4px 0',
                  justifyContent: 'flex-end',
                  minWidth: 'max-content',
                }}
              >
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  >
                    Grupo Físico:
                  </label>
                  <SelectConfGrupoFisico
                    onChange={this.handleFilterChange}
                    emptyText="Selecione"
                    customStyle={{
                      width: '180px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  />
                  <SelectConfControlador
                    anel={false}
                    onChange={this.handleFilterChange}
                    emptyText="Selecione"
                    customStyle={{
                      width: '260px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    htmlFor="agrupador"
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                    }}
                  >
                    Agrupar:
                  </label>
                  <select
                    id="agrupador"
                    className="form-control"
                    style={{
                      width: '180px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                    value={this.state.agrupador}
                    onChange={this.handleFilterChange}
                  >
                    <option value="0">Sem agrupamento</option>
                    <option value="5">5 min</option>
                    <option value="10">10 min</option>
                    <option value="15">15 min</option>
                    <option value="30">30 min</option>
                    <option value="60">60 min</option>
                  </select>
                </div>
                <button
                  type="button"
                  className="btn btn-default"
                  title="Imprimir lista filtrada"
                  onClick={this.handlePrint}
                  style={{
                    height: '38px',
                    width: '38px',
                    padding: 0,
                    border: '1px solid #bfd0e0',
                    borderRadius: '10px',
                    backgroundColor: '#ffffff',
                    color: '#475569',
                  }}
                >
                  <i className="fa fa-print" aria-hidden="true" />
                </button>
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <LogAdaptativoList
                  ref={this.listRef}
                  agrupador={this.state.agrupador}
                  dataInicio={this.state.dataInicio}
                  dataFim={this.state.dataFim}
                  onDateRangeChange={this.handleDateRangeChange}
                />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getLog, selectTab, showTabs }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(LogAdaptativo);
